import type { Options } from 'browser-update/update.npm';
import browserUpdate from 'browser-update/update.npm';
import Cookies from 'js-cookie';

import { Consts } from '../../consts';

interface OutdatedBrowserInfoTranslations {
  YourBrowserIsOutdated?: string;
  UpdateYourBrowser?: string;
  Update?: string;
}

export const outdatedBrowserInfo = (translations: OutdatedBrowserInfoTranslations) => {
  const options: Options = {
    required: { e: -3, f: -3, o: -3, s: -3, c: -3, i: 0 },
    reminder: 24,
    reminderClosed: 150,
    l: false,
    test: false,

    text_in_xx: '',
    newwindow: true,
    noclose: false,
    nomessage: false,
    jsshowurl: '//browser-update.org/update.show.min.js',
    container: document.body,

    no_permanent_hide: true,
    text: {
      msg: translations.YourBrowserIsOutdated ?? 'YourBrowserIsOutdated',
      msgmore: translations.UpdateYourBrowser ?? 'UpdateYourBrowser',
      bupdate: translations.Update?.toUpperCase() ?? 'Update',
    },
    onclose: () => {
      Cookies.set(Consts.SHOULD_BE_CLOSED_COOKIE, 'true');
    },
  };

  browserUpdate(options);
};
